import React, { Component } from 'react';
import '../../stylesheet/carddesign.css'
import logo from "../../images/gmcab-card-logo.png";
import chiplogo from "../../images/gmcab-chip-logo.png"
import prepaidvisa from "../../images/prepaid-visa1.png"
import wave from "../../images/whitevisa.png";
import Background from '../../images/GM-watermark-Transparent.png'

class CardDesign extends Component {

    render() {
        const { name, cardno, balance, startwith } = this.props

        return (
            <div className="carddesign ">
                <div className="card box-shadow-style" style={{backgroundImage: `url(${Background})`,backgroundRepeat: 'no-repeat',backgroundPosition: '87% 75%'}}>
                    <div className="bank-name">
                        <img src={logo} alt="GMCabs" />
                    </div>
                    <div className="chip">
                        <img src={chiplogo} alt="GMCabs" />
                        <img src={wave} alt="GMCabs" />
                    </div>
                    <div className="data">
                        <div className="pan">{cardno}</div>
                        <div className="first-digits">{startwith}</div>
                        <div className="exp-date-wrapper">
                            <div className="left-label">valid Thru</div>
                            <div className="exp-date">
                                {/* <div className="upper-labels">MONTH/YEAR</div> */}
                                <div className="date">{balance}</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-8 nopaddingright">
                                <div className="name-on-card">{name}</div>
                            </div>
                            <div className="col-sm-3 visacard nopadding">
                                <img src={prepaidvisa} alt="VISA" />
                            </div>
                        </div>

                    </div>
                    {/* <div className="lines-down"></div>
                    <div className="lines-up"></div> */}
                </div>
            </div>
        );
    }
}

export default CardDesign;


// WEBPACK FOOTER //
// ./src/components/carddesign/carddesign.jsx